
// The "Searching near ZIP: 02886 within 25 miles [Update]" row shared by every
// checkup step whose search is geographic — pharmacy, doctors and hospitals.
// It was pharmacy-only inline markup before (#598 follow-up: clients couldn't
// see, let alone change, the ZIP and radius their doctor/hospital results were
// scoped to, and pharmacy had no radius control at all).
//
// Fully controlled: the owning step holds `zip`/`distance` (mixins/
// checkup-search-scope.js) because it needs both for every search it fires,
// not just the ones this row triggers. Two `.sync` props plus one `update`
// event, rather than a self-contained widget, keeps that single source of
// truth in the step.
//
// Changing the radius emits `update` immediately (the select is a committed
// choice), while a typed ZIP waits for the button or Enter — re-searching on
// every keystroke of a 5-digit ZIP would fire four throwaway requests, and
// three of them against a ZIP that doesn't exist yet.
export default {
    props: {
        zip: { type: String, default: '' },
        distance: { type: Number, required: true },
        // Same {text, value} shape as the store's `distances` getter
        // (store/index.js) — passed in by the step rather than mapped here so
        // this part stays presentational.
        distances: { type: Array, required: true },
    },
    computed: {
        localZip: {
            get () { return this.zip },
            set (v) { this.$emit('update:zip', v) },
        },
        localDistance: {
            get () { return this.distance },
            set (v) {
                this.$emit('update:distance', Number(v))
                this.$emit('update')
            },
        },
    },
}
